import { Icon } from "@coverme/icons";
import * as PropTypes from "prop-types";
import React from "react";
import { getVerificationResult } from "../../services/verificationService";

export function MiniFacesheetVerification({ verifications, ...props }) {
    return (
        <>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Name </span>
                    {getVerificationResult(verifications.data.nameVerification)}
                </span>
            </div>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">SSN </span>
                    {getVerificationResult(verifications.data.ssnVerification)}
                </span>
            </div>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">DOB </span>
                    {getVerificationResult(verifications.data.dateOfBirthVerification)}
                </span>
            </div>
            <div className="mini-facesheet__info-item">
                <span className="p-regular">
                    <span className="h5">Address </span>
                    {getVerificationResult(verifications.data.addressVerification)}
                </span>
            </div>
        </>
    );
}
